if (!document.body.classList.contains('knoops-gmap-init')) {
  
  window.initMaps = function() {
    if (typeof window.google === 'undefined') return false;

    // 1. Loop through every map container on the page
    document.querySelectorAll('.knoops-gmap').forEach(mapContainer => {
      let zoom = 8;
      let center = { lat: 51.5150566, lng: -0.1020399 };

      // Knoops Silver Map Styling
      const std_silver = [
        {"elementType": "geometry", "stylers": [{"color": "#f5f5f5"}]},
        {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
        {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
        {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"}]},
        {"featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{"color": "#bdbdbd"}]},
        {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
        {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
        {"featureType": "poi.attraction", "stylers": [{"visibility": "on"}]},
        {"featureType": "poi.medical", "stylers": [{"visibility": "on"}]},
        {"featureType": "poi.park", "stylers": [{"visibility": "on"}]},
        {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
        {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
        {"featureType": "poi.place_of_worship", "stylers": [{"visibility": "on"}]},
        {"featureType": "poi.school", "stylers": [{"visibility": "on"}]},
        {"featureType": "poi.sports_complex", "stylers": [{"visibility": "on"}]},
        {"featureType": "road", "stylers": [{"weight": 1}]},
        {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
        {"featureType": "road", "elementType": "geometry.stroke", "stylers": [{"color": "#cbcbcb"}, {"weight": 1}]},
        {"featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
        {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"}]},
        {"featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
        {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
        {"featureType": "transit", "stylers": [{"visibility": "on"}]},
        {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
        {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
        {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#d5d5d5"}]},
        {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}
      ];

      // Parse data attributes
      try { if (mapContainer.dataset.center) center = JSON.parse(mapContainer.dataset.center); } catch (e) {}
      if (mapContainer.dataset.zoom) zoom = parseInt(mapContainer.dataset.zoom, 10);

      const mapSettings = { disableDefaultUI: true, center: center, zoom: zoom, styles: std_silver };
      if (mapContainer.dataset.enablezoom === "yes") mapSettings.zoomControl = true;

      const mapTarget = mapContainer.querySelector('.map-container');
      if (!mapTarget) return;

      const gmap = new window.google.maps.Map(mapTarget, mapSettings);

      const knoops_icon = {
        path: 'M20,0A20,20,0,0,0,0,20C0,31,14.65,52.15,20,52.15,23.87,52.15,40,31,40,20A20,20,0,0,0,20,0Zm2.64,20h-.2v8.67H20.09V11.33h2.35v7.49h.2l7.66-7.49h3.28l-8.37,8,8.94,9.33H30.72Z',
        fillColor: '#dcad71', scale: 1, fillOpacity: 1, strokeOpacity: 0,
        anchor: new window.google.maps.Point(20, 52.15)
      };

      const decodeHTML = (html) => { const txt = document.createElement("textarea"); txt.innerHTML = html; return txt.value; };

      let markers = [], potential_icon = [], potential_infoboxes = [];
      try { if (mapContainer.dataset.gmapmarkers) markers = JSON.parse(mapContainer.dataset.gmapmarkers); } catch (e) {}
      try { if (mapContainer.dataset.gmapicons) potential_icon = JSON.parse(mapContainer.dataset.gmapicons); } catch (e) {}
      try { if (mapContainer.dataset.gmapinfoboxes) potential_infoboxes = JSON.parse(mapContainer.dataset.gmapinfoboxes); } catch (e) {}

      const markers_array = [];
      const bounds = new window.google.maps.LatLngBounds();

      markers.forEach((gmap_marker, gmap_index) => {
        const markerProps = { position: gmap_marker, map: gmap };

        if (potential_icon[gmap_index] && potential_icon[gmap_index] !== 'none') {
          if (potential_icon[gmap_index].includes('{')) {
            try { markerProps.icon = Object.assign({ anchor: new window.google.maps.Point(20, 52.15) }, JSON.parse(decodeHTML(potential_icon[gmap_index]))); } 
            catch (e) { markerProps.icon = knoops_icon; }
          } else { markerProps.icon = potential_icon[gmap_index]; }
        } else { markerProps.icon = knoops_icon; }

        const marker = new window.google.maps.Marker(markerProps);

        if (potential_infoboxes[gmap_index] && potential_infoboxes[gmap_index] !== 'none') {
          const domEle = document.createElement('div');
          domEle.innerHTML = decodeHTML(potential_infoboxes[gmap_index]);
          const potInfoBox = new window.google.maps.InfoWindow({ content: domEle });
          marker.addListener("click", () => potInfoBox.open({ anchor: marker, map: gmap }));
        }

        markers_array.push(marker);
        bounds.extend(gmap_marker);
      });

      if (markers.length === 1) {
        gmap.setCenter(markers_array[0].getPosition());
      } else if (markers.length > 1) {
        gmap.fitBounds(bounds);
        const listener = window.google.maps.event.addListener(gmap, "idle", () => {
          gmap.setZoom(gmap.getZoom() - 1);
          window.google.maps.event.removeListener(listener);
        });

        // ==========================================
        // START POSTCODE LOOKUP BEHAVIORS (Vanilla)
        // ==========================================
        const title = mapContainer.querySelector('.suggestion-box .title');
        const results = mapContainer.querySelector('.suggestion-box .list');
        const input = mapContainer.querySelector('input.search-location-gmaps');
        const controlContainer = mapContainer.querySelector('.suggestion-box');
        const distanceSelect = mapContainer.querySelector('select.search-location-distance');

        if (input && controlContainer) {
          const fetchPostcodeData = async (postcode) => {
            const response = await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(postcode)}`);
            if (!response.ok) throw new Error('Postcode not found.');
            const data = await response.json();
            if (data.status !== 200) throw new Error(data.error || 'Error fetching postcode data.');
            return data.result;
          };

          const isValidPostcode = (postcode) => /^([A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2})$/i.test(postcode);

          const debounce = (func, delay) => {
            let timeoutId;
            return (...args) => {
              if (timeoutId) clearTimeout(timeoutId);
              timeoutId = setTimeout(() => func(...args), delay);
            };
          };

          const handlePostcodeSearch = async () => {
            const postcode = input.value.trim().toUpperCase();
            if (postcode === '') {
              title.innerText = "";
              controlContainer.classList.add('inactive');
              markers_array.forEach(m => m.setMap(gmap)); // Reset map pins
              gmap.fitBounds(bounds);
              return;
            }

            title.innerText = "Searching...";
            controlContainer.classList.remove('inactive');

            if (postcode.length >= 4) {
              if (!isValidPostcode(postcode)) {
                title.innerText = "Invalid postcode format. Please enter a valid UK postcode.";
                results.replaceChildren();
                input.classList.add('input-error');
                return;
              } else {
                input.classList.remove('input-error');
              }

              try {
                const postcodeData = await fetchPostcodeData(postcode);
                const { latitude, longitude, postcode: formattedPostcode } = postcodeData;
                const newCenter = new window.google.maps.LatLng(latitude, longitude);
                
                const milesRadius = parseInt(distanceSelect.value, 10);
                const acceptableDistance = milesRadius * 1609.34; // meters

                gmap.setCenter(newCenter);
                gmap.setZoom(12);

                let availableMarkers = [];
                let newBounds = new window.google.maps.LatLngBounds();

                markers_array.forEach(marker => {
                  const distanceBetween = window.google.maps.geometry.spherical.computeDistanceBetween(marker.getPosition(), newCenter);
                  if (distanceBetween <= acceptableDistance) {
                    availableMarkers.push(marker);
                    newBounds.extend(marker.getPosition());
                    marker.setMap(gmap); // Show marker
                  } else {
                    marker.setMap(null); // Hide marker
                  }
                });

                if (availableMarkers.length > 0) {
                  gmap.fitBounds(newBounds);
                  const currentZoom = gmap.getZoom();
                  gmap.setZoom(currentZoom > 18 ? 18 : currentZoom - 1);
                  title.innerText = `Stores within ${milesRadius} mile(s) of "${formattedPostcode}":`;
                  controlContainer.classList.add('inactive');
                } else {
                  title.innerText = "No stores found within the specified distance.";
                }
                results.replaceChildren();
              } catch (error) {
                title.innerText = `Error: ${error.message}`;
                results.replaceChildren();
              }
            } else {
              title.innerText = "Please enter at least 4 characters to search";
              results.replaceChildren();
            }
          };

          const debouncedSearch = debounce(handlePostcodeSearch, 500);

          input.addEventListener("input", debouncedSearch);
          distanceSelect.addEventListener("change", handlePostcodeSearch); // Re-run if radius changes
          input.addEventListener("keydown", (e) => {
            if (e.key === 'Enter') {
              e.preventDefault(); // Stop form submission
              handlePostcodeSearch();
            }
          });
        }
        // ==========================================
        // END POSTCODE LOOKUP BEHAVIORS
        // ==========================================
      }
      mapContainer.knoopsGmap = gmap;
    });
  };

  // Inject the script with the GEOMETRY library
  const script = document.createElement('script');
  const apiKey = window.theme.gmapsApiKey; // <--- PASTE YOUR KEY HERE
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMaps&libraries=geometry`;
  document.head.appendChild(script);
  document.body.classList.add('knoops-gmap-init');

} else {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initMaps);
  } else {
    window.initMaps();
  }
}